import Vue from 'vue'
import Router from 'vue-router'
import { token } from '../common/session'
import store from '../store'
import { listParams } from '../common/customer'
import { recordCustomerJourney } from '../common/customer-return'
import Login from '../pages/login'
import Workbench from '../pages/workbench'
import DailyBrief from '../pages/daily-brief'
import Customer from '../pages/customer/index'
import CustomerSearch from '../pages/customer/search'
import CustomerCheck from '../pages/customer/check'
import CustomerCreate from '../pages/customer/create'
import CustomerEdit from '../pages/customer/edit'
import CustomerDetail from '../pages/customer/detail'
import Schedule from '../pages/schedule/index'
import Employee from '../pages/employee/index'
import Remind from '../pages/remind/index'
import Task from '../pages/task/index'
import TaskEdit from '../pages/task/edit'
Vue.use(Router)
const router = new Router({
  mode: 'history',
  scrollBehavior(to, from, saved) {
    if (to.name === 'schedule' && to.path === from.path) return false
    const key = { customer: 'customers', remind: 'reminders', workbench: 'workbench' }[to.name]
    const cache = key && store.state.views[key]
    const signature = to.name === 'customer' ? JSON.stringify(listParams(store.state.search)) : '{}'
    if (cache && cache.revision === store.state.revision && (to.name === 'workbench' || cache.signature === signature)) return false
    return saved || { x: 0, y: 0 }
  },
  routes: [
    { path: '/', name: 'login', component: Login },
    { path: '/workbench', name: 'workbench', component: Workbench },
    { path: '/daily-brief', name: 'daily-brief', component: DailyBrief },
    { path: '/customer', name: 'customer', component: Customer },
    { path: '/schedule', name: 'schedule', component: Schedule },
    { path: '/customer/prospect', redirect: '/schedule' },
    { path: '/customer/search', name: 'customer-search', component: CustomerSearch },
    { path: '/customer/check', name: 'customer-check', component: CustomerCheck },
    { path: '/customer/create/:mobile', name: 'customer-create', component: CustomerCreate },
    { path: '/customer/edit/:id/:from', name: 'customer-edit', component: CustomerEdit },
    { path: '/customer/detail/:id/:from?', name: 'customer-detail', component: CustomerDetail },
    { path: '/employee', name: 'employee', component: Employee },
    { path: '/remind', name: 'remind', component: Remind },
    { path: '/task', name: 'task', component: Task },
    { path: '/task/edit/:id', name: 'task-edit', component: TaskEdit },
    { path: '*', redirect: '/workbench' }
  ]
})
router.beforeEach((to, from, next) => {
  if (to.name !== 'login' && !token()) next({ path: '/', query: { redirect: to.fullPath } })
  else next()
})
router.afterEach((to, from) => recordCustomerJourney(store, to, from))
export default router



// WEBPACK FOOTER //
// ./src/router/index.js